$(window).on "load", ->
  $(".panel-delayed")
    .delay(1000)
    .slideDown()
